module.exports = __webpack_public_path__ + "static/media/logo.31c7b2b5.png";